import * as React from 'react';
import { Button, CircularProgress, type ButtonProps } from '@mui/material';

type AsyncSaveButtonProps = Omit<ButtonProps, 'endIcon' | 'children'> & {
  label?: string;
  savingLabel?: string;
  isSaving: boolean;
  onClick?: () => void;
  endIconWhenIdle?: React.ReactNode;
};

export function AsyncSaveButton({
  label = 'Save',
  savingLabel = 'Saving...',
  isSaving,
  onClick,
  endIconWhenIdle,
  disabled,
  ...buttonProps
}: AsyncSaveButtonProps) {
  return (
    <Button
      {...buttonProps}
      onClick={onClick}
      disabled={isSaving || !!disabled}
      endIcon={!isSaving ? endIconWhenIdle : undefined}
    >
      {isSaving ? (
        <>
          <CircularProgress size={20} color="inherit" style={{ marginRight: 8 }} />
          {savingLabel}
        </>
      ) : (
        label
      )}
    </Button>
  );
}